import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { User, AuthService } from 'ac-ui-core-local';

@Component({
	selector: 'azc-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
	public user?: User;

	constructor(private _as: AuthService, private router: Router) { }

	ngOnInit() {
		this._as.watchUser().subscribe(x => this.user = x);
	}

	async logout() {
		await this._as.logout();
		this.router.navigate(['/']);
	}
}
